module.exports = __webpack_public_path__ + "img/placeholder/section-cta.jpg";